import { ServiceHandler } from '../../../utils/api.utils';
import type { FeedbackRequest } from '../types';

export const submitFeedback = ServiceHandler<FeedbackRequest, void>({
  url: '/api/chat-agent/v1/messages/:messageId/feedback',
  method: 'POST',
});
